<div class="loan-offers-widget" [class.loan-offers-widget--small]="size === 'small'"
    [class.loan-offers-widget--medium]="size === 'medium'" [class.loan-offers-widget--half]="size === 'half'"
    [class.loan-offers-widget--full]="size === 'full'" [style.height.px]="dynamicMaxHeight"
    [style.maxHeight.px]="dynamicMaxHeight">

    <!-- Loading State -->
    <div *ngIf="isLoading" class="widget-loader">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>

    <!-- Error/Register State (Wrapped in Carousel for consistency) -->
    <app-carousel-slider *ngIf="!isLoading && errorMessage" [items]="['error']" [title]="title" [showCount]="false"
        [isEditMode]="isEditMode" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
        [getAvailableSizes]="getAvailableSizes" [toggleSizeDropdown]="toggleSizeDropdown"
        [changeWidgetSize]="changeWidgetSize" [removeWidget]="removeWidget" [isAddMode]="isAddMode"
        (addWidget)="addWidget.emit()">

        <ng-template #cardTemplate>
            <div class="product-selection-container">
                <h6 class="selection-title">
                    Compare, Choose & Apply for Loan, Credit & Insurance Products
                </h6>

                <div class="product-grid">
                    <!-- Personal Loans -->
                    <div class="product-card" (click)="openRegistration()">
                        <div class="product-icon-wrapper">
                            <img src="https://creditlinks-lap.s3.ap-south-1.amazonaws.com/static/1702279151-Icon%20-%20Personal%20Loans.png"
                                alt="Personal Loans" class="product-icon no-dark-filter">
                        </div>
                        <div class="product-info">
                            <div class="product-name">Personal Loans</div>
                            <p class="product-description">Quick approvals for salaried & self-employed individuals.</p>
                        </div>
                    </div>

                    <!-- Insurance -->
                    <div class="product-card" (click)="openRegistration()">
                        <div class="product-icon-wrapper">
                            <img src="https://creditlinks-lap.s3.ap-south-1.amazonaws.com/static/1702279118-Icon%20-%20Insurance.png"
                                alt="Insurance" class="product-icon no-dark-filter">
                        </div>
                        <div class="product-info">
                            <div class="product-name">Insurance</div>
                            <p class="product-description">Comprehensive insurance coverage for peace of mind.</p>
                        </div>
                    </div>

                    <!-- Credit Cards -->
                    <div class="product-card" (click)="openRegistration()">
                        <div class="product-icon-wrapper">
                            <img src="https://creditlinks-lap.s3.ap-south-1.amazonaws.com/static/1702278908-Icon%20-%20Credit%20Cards.png"
                                alt="Credit Cards" class="product-icon no-dark-filter">
                        </div>
                        <div class="product-info">
                            <div class="product-name">Credit Cards</div>
                            <p class="product-description">Experience financial flexibility with attractive rewards.</p>
                        </div>
                    </div>

                    <!-- Gold Loans -->
                    <div class="product-card" (click)="openRegistration()">
                        <div class="product-icon-wrapper">
                            <img src="https://creditlinks-lap.s3.ap-south-1.amazonaws.com/static/1702279056-Icon%20-%20Gold%20Loans.png"
                                alt="Gold Loans" class="product-icon no-dark-filter">
                        </div>
                        <div class="product-info">
                            <div class="product-name">Gold Loans</div>
                            <p class="product-description">Maximize your gold's value. Safe & transparent lending.</p>
                        </div>
                    </div>

                    <!-- Business Loans -->
                    <div class="product-card" (click)="openRegistration()">
                        <div class="product-icon-wrapper">
                            <img src="https://creditlinks-lap.s3.ap-south-1.amazonaws.com/static/1702278623-Icon%20-%20Business%20Loans.png"
                                alt="Business Loans" class="product-icon no-dark-filter">
                        </div>
                        <div class="product-info">
                            <div class="product-name">Business Loans</div>
                            <p class="product-description">Tailored solutions to help you grow your business.</p>
                        </div>
                    </div>

                    <!-- Discount Vouchers -->
                    <div class="product-card" (click)="openRegistration()">
                        <div class="product-icon-wrapper">
                            <img src="https://creditlinks-lap.s3.ap-south-1.amazonaws.com/static/1702278992-Icon%20-%20Discount%20Vouchers.png"
                                alt="Discount Vouchers" class="product-icon no-dark-filter">
                        </div>
                        <div class="product-info">
                            <div class="product-name">Discount Vouchers</div>
                            <p class="product-description">Exclusive discounts on top brands. Save big on every
                                purchase!</p>
                        </div>
                    </div>

                    <!-- Business Loans -->
                    <div class="product-card" (click)="openRegistration()">
                        <div class="product-icon-wrapper">
                            <img src="https://creditlinks-lap.s3.ap-south-1.amazonaws.com/static/1749643193-housing-loan.webp"
                                alt="Business Loans" class="product-icon no-dark-filter">
                        </div>
                        <div class="product-info">
                            <div class="product-name">Affordable Housing Loan</div>
                            <p class="product-description">Affordable Housing Loan.</p>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </app-carousel-slider>

    <!-- Content State -->
    <app-carousel-slider *ngIf="!isLoading && !errorMessage" [items]="offers" [title]="title" [showCount]="true"
        [isEditMode]="isEditMode" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
        [getAvailableSizes]="getAvailableSizes" [toggleSizeDropdown]="toggleSizeDropdown"
        [changeWidgetSize]="changeWidgetSize" [removeWidget]="removeWidget" [isAddMode]="isAddMode"
        (addWidget)="addWidget.emit()">
        <ng-template #cardTemplate let-offer>
            <app-loan-offer-card [offer]="offer" (selectLoan)="onOfferSelected(offer)">
            </app-loan-offer-card>
        </ng-template>
    </app-carousel-slider>

    <app-registration-modal *ngIf="showRegistrationModal" [mobileNumber]="userMobile" (close)="closeRegistration()"
        (success)="onRegistrationSuccess($event)">
    </app-registration-modal>
</div>